<template>
  <div v-if="url.isExpanded">
    <div v-if="isLoaderVisible" class="common-table__row url-keyword__horizontal-loader-wrap">
      <base-horizontal-loader class="url-keyword__horizontal-loader"/>
    </div>
    <div v-else>
      <div class="common-table__row url-keyword__header">
        <div v-for="cell in keywordConfig"
             :style="cell.style"
             class="common-table__header-cell"
             :key="cell.propName">{{cell.label}}
        </div>
      </div>
      <div v-if="childrenSize">
        <div v-for="keyword in preparedChildren"
             class="common-table__row"
             :key="keyword.label">
          <div v-for="cell in keywordConfig"
               :style="cell.style"
               class="common-table__cell"
               :key="cell.propName">{{keyword[cell.propName] | cell.filterName}}
          </div>
        </div>
        <div class="pagination-wrapper" v-if="hasPagination">
          <base-pagination :totalItems="childrenSize"
                           :limit="itemsLimit"
                           @pageChanged="prepareChildren"/>
        </div>
      </div>
      <div v-else class="common-table__row url-keyword__no-data">Awaiting Data</div>
    </div>
  </div>
</template>

<script>
import filters from '@/common/Filters'
import _ from 'lodash'
// eslint-disable-next-line no-unused-vars
import UrlPlanning from './UrlPlanning'
/**
 * table config
 * */
const keywordConfig = [
  {
    label: 'Keyword',
    propName: 'label',
    style: {
      'flex-basis': '21%',
      'padding-left': '45px'
    }
  },
  {
    label: '01 - 03',
    propName: '01 - 03',
    filterName: 'commaDividedNumber',
    style: {
      'flex-basis': '3%'
    }
  },
  {
    label: '04 - 07',
    propName: '04 - 07',
    filterName: 'commaDividedNumber',
    style: {
      'flex-basis': '3%'
    }
  },
  {
    label: '08 - 10',
    propName: '08 - 10',
    filterName: 'commaDividedNumber',
    style: {
      'flex-basis': '3%'
    }
  },
  {
    label: '11 - 25',
    propName: '11 - 25',
    filterName: 'commaDividedNumber',
    style: {
      'flex-basis': '3%'
    }
  },
  {
    label: '26 - 50',
    propName: '26 - 50',
    filterName: 'commaDividedNumber',
    style: {
      'flex-basis': '3%'
    }
  },
  {
    label: '51 - 100',
    propName: '51 - 100',
    filterName: 'commaDividedNumber',
    style: {
      'flex-basis': '3%'
    }
  },
  {
    label: 'NR',
    propName: 'NR',
    filterName: 'commaDividedNumber',
    style: {
      'flex-basis': '3%'
    }
  },
  {
    label: 'ND',
    propName: 'ND',
    filterName: 'commaDividedNumber',
    style: {
      'flex-basis': '3%'
    }
  },
  {
    label: 'Total',
    propName: 'total_msv',
    filterName: 'commaDividedNumber',
    style: {
      'flex-basis': '3%',
      'padding-right': '20px'
    }
  }
]

/**
 * Component shows us keywords data for specific row in the {@link UrlPlanning} table
 */
export default {
  name: 'UrlKeywordTable',
  props: {
    url: {
      type: Object,
      default: () => {
      }
    }
  },
  watch: {
    'url.children': {
      handler () {
        const topEdge = this.itemsLimit
          ? this.itemsLimit
          : this.url.children.length
        this.prepareChildren({ from: 0, to: topEdge })
      }
    }
  },
  data () {
    return {
      keywordConfig,
      itemsLimit: 10, // max number of ites in the list
      preparedChildren: []
    }
  },
  computed: {
    hasPagination () {
      const limit = this.itemsLimit
      return limit && limit < this.childrenSize
    },
    childrenSize () {
      return this.url && this.url.children ? this.url.children.length : 0
    },
    isLoaderVisible () {
      return !this.url.children
    }
  },
  methods: {
    /**
     * used for paginated keywords table
     * @param props - {from: Number, to: Number}
     */
    prepareChildren (props) {
      if (this.childrenSize) {
        this.preparedChildren = _.cloneDeep(this.url.children.slice(props.from, props.to))
      } else {
        this.preparedChildren = _.cloneDeep(this.url.children)
      }
    }
  },
  filters: {
    commaDividedNumber: filters.commaDividedNumber,
    formattedDate: filters.formattedDate
  }
}
</script>

<style scoped lang="scss">
  .common-table {
    border-radius: $rfx-default-border-radius;

    &__header {
      background-color: rgba(1, 22, 39, 0.1);
      border-top-right-radius: 4px;
      border-top-left-radius: 4px;
    }

    &__header-cell {
      color: $rfx-dark-march;
      font-weight: bold;
      padding: 0;
      height: 40px;
      display: flex;
      align-items: center;
      cursor: pointer;

      &:first-child {
        padding-left: 25px;
      }

      &:last-child {
        padding-right: 25px;
      }
    }

    &__cell {
      height: 40px;
      padding: 0;
      display: flex;
      align-items: center;
      font-size: 14px;
      border-bottom: 1px solid $rfx-light-steel;

      &:first-child {
        padding-left: 25px;
      }

      &:last-child {
        padding-right: 25px;
      }
    }

    &__row {
      border-left: 1px solid $rfx-light-steel;
      border-right: 1px solid $rfx-light-steel;
    }
  }

  .url-keyword {
    &__header {
      background-color: rgba(1, 22, 39, 0.1);
    }

    &__no-data {
      display: flex;
      height: 40px;
      background-color: #fff;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-weight: 500;
      color: $rfx-medium-grey;
      flex: 1 1 100%;
      border-bottom: 1px solid $rfx-light-steel;
    }

    &__horizontal-loader-wrap {
      height: 60px;
      box-sizing: border-box;
      overflow: hidden;
      padding: 0;
      position: relative;
      border-bottom: 1px solid $rfx-light-steel;
    }

    &__horizontal-loader {
      position: absolute;
      top: -2px;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .pagination-wrapper {
    display: flex;
    height: 40px;
    justify-content: center;
    align-items: center;
    border: 1px solid $rfx-light-steel;
    border-top: none;
  }
</style>
